import { apiInterfaceForJson } from '../common/apiManager';

export const clientOnboardProcess = (clientOnboardInfo) => {
    return apiInterfaceForJson('/company/v1/clientonboard', 'POST', clientOnboardInfo);
};
